import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

export const countryInterceptor: HttpInterceptorFn = (req, next) => {
  // En lugar de inyectar el servicio, leer directamente del localStorage
  const countryIso = localStorage.getItem('selectedCountryIso');
  
  // Si no hay país o la URL es para endpoints que no necesitan el país
  if (!countryIso || 
      req.url.includes('/api/countries') || 
      req.url.includes('/select-country')) {
    return next(req);
  }
  
  // Clonar la petición añadiendo el país
  const modifiedReq = req.clone({
    params: req.params.set('country', countryIso)
  });
  
  // Continuar con la petición modificada
  return next(modifiedReq);
};